<template>
  <div>
    <empty-state
      v-if="isLoading || !data || data.length === 0"
      :loading="isLoading"
      :title="isLoading ? $t('loading') : $t('no_data_available')"
      :subtitle="!isLoading ? $t('no_namirnice_found') : ''"
      icon="mdi-food-apple"
    />
    <v-card v-else flat>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="data"
          :search="searchQuery"
          class="striped-table"
          :loading="isLoading"
        >
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import EmptyState from "@/components/global/EmptyState.vue";

export default {
  name: "NamirniceTab",
  components: {
    EmptyState,
  },
  props: {
    searchQuery: String,
    dateRange: Array,
  },
  data() {
    return {
      data: [],
      isLoading: false,
      headers: [
        { text: this.$t("r_b"), value: "num", sortable: false },
        { text: this.$t("namirnice"), value: "name", sortable: true },
        { text: this.$t("quantity"), value: "quantity", sortable: true },
      ],
    };
  },
  watch: {
    dateRange: {
      handler() {
        this.loadData();
      },
      immediate: true,
    },
  },
  methods: {
    loadData() {
      // TODO: Implement API call
      console.log("Loading namirnice data for:", this.dateRange);
    },
  },
};
</script>
